module.exports = __webpack_public_path__ + "h5/img/milestone-technology.eb814492.jpg";